import { Component, Input } from '@angular/core';
import {
  GenericDocAllService,
  CashTransferService,
  Pagination
} from "blg-akaun-ts-lib";
import { ToastrService } from 'ngx-toastr';
import { SubSink } from 'subsink2';
import { SessionStates } from '../modules/session/session-controller/states';
import { SessionActions } from '../modules/session/session-controller/actions';
import { Store } from '@ngrx/store';
import { AppStates } from '../application-controller/store/states';
import { ViewColActions } from '../application-controller/store/actions';

@Component({
  selector: 'app-cell-click-handler',
  template: ''
})
export class CellClickHandlerComponent {
  @Input() apiVisa: any;

  protected subs = new SubSink();

  constructor(
    private readonly appStore: Store<AppStates>,
    private readonly cashTransferService: CashTransferService,
    private readonly sessionStore: Store<SessionStates>,
    private toastr: ToastrService,
    protected genericDocService: GenericDocAllService
  ) {}

  onCellClicked(guid: any, serverDoc1: string, serverDocType: string) {
    console.log('onCellClicked',serverDoc1, serverDocType)
    if (serverDocType === 'INTERNAL_CASH_TRANSFER' || serverDocType === 'INTERNAL_CASH_ADJUSTMENT') {
      this.getCashDoc(guid);
    } else {
      this.getGenericDoc(serverDocType, serverDoc1);
    }

  }

  private getGenericDoc(serverDocType: string, serverDocNo: string) {
    const criteria = [
      { columnName: 'server_doc_type', operator: '=', value: serverDocType },
      { columnName: 'server_doc_1', operator: '=', value: serverDocNo }
    ];

    const paging = new Pagination(0, 1, criteria, null);
    this.subs.sink = this.genericDocService.getByCriteria(paging, this.apiVisa).subscribe(resp => {
      if (resp.data.length > 0) {
        this.sessionStore.dispatch(SessionActions.selectGenericDocPopup({genericDoc: resp.data[0]}))
        this.onNextItem(1);
      } else {
        this.toastr.error(
          'The Generic Document does not exist',
          'Error',
          {
            tapToDismiss: true,
            progressBar: true,
            timeOut: 1300
          }
        );
      }
    });
  }

  private getCashDoc(guid: string) {
    this.subs.sink = this.cashTransferService.getByGuid(guid, this.apiVisa).subscribe(resp => {
      if (resp.data) {
        this.sessionStore.dispatch(SessionActions.selectCashDocPopup({cashDoc: resp.data[0]}))
      } else {
        this.toastr.error(
          'The Cash Document does not exist',
          'Error',
          {
            tapToDismiss: true,
            progressBar: true,
            timeOut: 1300
          }
        );
      }
    });
  }

  onNextItem(index) {
    this.appStore.dispatch(ViewColActions.viewColNextAndReset({curIndex:0, nextIndex:1}));
  }
}
